import { Component, ViewChild, ViewChildren, QueryList, ElementRef, OnInit, AfterViewInit, AfterViewChecked, ViewEncapsulation, ChangeDetectorRef, HostListener } from '@angular/core';
import { MainService } from './main.service';
import { environment } from '../environments/environment';
import { BrowserModule, DomSanitizer, SafeStyle, SafeResourceUrl } from '@angular/platform-browser'
import { Title } from "@angular/platform-browser";
import { Subscription, animationFrameScheduler, interval, timer, of, Observable, scan, takeWhile, last, filter, tap, map, forkJoin, fromEvent, Subject, switchMap, takeUntil } from 'rxjs';
import { ElectronService } from 'ngx-electron';

import * as THREE from 'three';
import { OrbitControls } from 'three-orbitcontrols-ts';

import { Camera, Story, Stitch, Effects, Effect, Choice, Flag } from "./classes";
import { TypeCheckCompiler } from '@angular/compiler/src/view_compiler/type_check_compiler';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', './app.component-responsive.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewChecked {

  public currentUrl: string;
  public debug: boolean = true;
  public timecodes: boolean = true;
  public export: boolean = false;
  public inkleId: string = '';
  public inkleIdEn: string = '';
  public kiosk: boolean = true;
  public background: boolean = true;

  private datasServer: any;
  public datasName: any;
  public base: string;
  public datas: any;
  public datasdev: any;

  public lang: number = 0;
  public story: Story;
  public stories: Story;

  // public effects: Effects;
  public title: string;
  public stitch: Stitch;
  public selected: number;
  public status: string = 'loading'; // loading, stitch, transition, keyboard...
  
  public homeStitch: boolean;

  public homeQuestion: boolean;
  public wide: boolean = false;
  public mute: boolean = false;
  public credits: boolean = false;

  public history: Array<Stitch>;

  public loaded: boolean = false;
  public afterViewChecked: boolean = false;
  public startDone: boolean = false;

  private activityDelay: number = 5 * 60 * 1000; //ms
  private activitySubscription: Subscription;

  private transitionDelay: number = 1 * 1000; //ms
  private transitionSubscription: Subscription;

  @ViewChild('canvas')
  public canvasRef: ElementRef;
  private canvas: HTMLCanvasElement;

  @ViewChild('canvasImg')
  public canvasImgRef: ElementRef;

  private canvasImg: HTMLCanvasElement;
  private canvasImgCtx: CanvasRenderingContext2D;
  private canvasImgWidth: number = 101;
  private canvasImgHeight: number = 101;

  public rotationSpeedX: number = 0.05;
  public rotationSpeedY: number = 0.01;
  public size: number = 200;
  public texture: string = "./assets/texture.jpg";

  //* Stage Properties
  public fieldOfView: number = 50;
  public nearClippingPlane: number = 1;
  public farClippingPlane: number = 2800;

  private camera!: THREE.PerspectiveCamera;
  private controls: any;

  private loader = new THREE.TextureLoader();
  private geometry = new THREE.BoxGeometry(500, 500, 500);

  // private material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
  private materialWhite = new THREE.MeshBasicMaterial({ color: 0xcccccc });
  // private material = new THREE.MeshBasicMaterial({ map: this.loader.load(this.texture) });
  // private material = new THREE.MeshPhongMaterial({
  //   color: 0xdddddd,
  //   wireframe: true
  // });

  private intervals: Array<any>;

  private elevations: Array<number>;
  private elevationsTarget: Array<number>;
  private spheres: Array<THREE.Mesh>;

  private cameraPos: Camera;
  private cameraPosTarget: Camera;
  private cameraMvt: Camera;

  private effect: Effect;
  public image: SafeStyle;
  public loopPlayer: HTMLAudioElement;
  public audioPlayer: HTMLAudioElement;
  public filter: string;

  public started: boolean = false;

  public speed: number = 1;
  public amplitude: number = 1;
  public speedTarget: number = 1;
  public amplitudeTarget: number = 1;

  public time: number = 0;
  public lastTick: number = 0;
  public ips: number;
  private renderer!: THREE.WebGLRenderer;

  private scene!: THREE.Scene;

  public stitch_duration: number = 0;
  private countDown$: Observable<number> = timer(0, 1000).pipe(
    takeWhile((val) => val < this.stitch_duration)
  );
  public countDown: number;
  public countDownSubscription: Subscription;

  public conclusionIndex: number;
  public conclusionMenu: boolean;

  @ViewChildren('video')
  videoTag: QueryList<ElementRef>;

  private videoObservable;
  private trackObservable;
  public webvtt;

  // textTracks[0];
  // var cue = track.cues[0];

  public currentVideo;
  public loop;
  public videoFolders;
  public videoSubscription;
  public videoProgress;

  @ViewChild('progressBar')
  public progressBar: ElementRef;

  public keyboard: boolean = false;
  // public letters: Array<string> = "abcdefghijklmnopqrstuvwxyz-".split('');
  public line0: Array<string> = "azertyuiop".split('');
  public line1: Array<string> = "qsdfghjklm".split('');
  public line2: Array<string> = "wxcvbn-".split('');
  public lines: Array<Array<string>> = [this.line0, this.line1, ['◄', ...this.line2]];
  public pseudo: string;

  public sanitized: Array<any>;

  public mousedown: Subject<MouseEvent> = new Subject<MouseEvent>();
  public mousemove: Subject<MouseEvent> = new Subject<MouseEvent>();
  public mouseup: Subject<MouseEvent> = new Subject<MouseEvent>();

  public dragStart = this.mousedown;
  public dragMove = this.dragStart.pipe(
    switchMap((start) => this.mousemove.pipe(
      map((moveEvent) => {
        let ret = {
          originalEvent: moveEvent,
          deltaX: moveEvent.pageX - start.pageX,
          deltaY: moveEvent.pageY - start.pageY,
          x0: start.pageX,
          y0: start.pageY,
          startOffsetX: start.offsetX,
          startOffsetY: start.offsetY
        };
        return ret;
      }),
      takeUntil(this.mouseup)
    )
    ),
  );
  public dragEnd = this.dragStart.pipe(
    switchMap((start) => this.mousemove.pipe(
      map((moveEvent) => {
        let ret = {
          originalEvent: moveEvent,
          deltaX: moveEvent.pageX - start.pageX,
          deltaY: moveEvent.pageY - start.pageY,
          x0: start.pageX,
          y0: start.pageY,
          startOffsetX: start.offsetX,
          startOffsetY: start.offsetY
        };
        return ret;
      }),
      takeUntil(this.mouseup),
      last()
    )),
  );
  public dragging:boolean;
  public paused:boolean;

  constructor(
    private service: MainService,
    public sanitizer: DomSanitizer,
    private titleService: Title,
    private electron: ElectronService,
    private cdf: ChangeDetectorRef,
  ) {
    this.currentUrl = window.location.href.split('#')[0];
  }


  /**********************************************************************/
  /* INIT & LOAD & START **************************************************************/

  isElectron(): boolean {
    return window.hasOwnProperty('process') && window['process'].hasOwnProperty('versions') && window['process']['versions'].hasOwnProperty('electron');
  }

  ngOnInit(): void {
    console.log('ngOnInit', environment);
    if (this.isElectron()) { // electron
      let response: any = this.electron.ipcRenderer.sendSync('ping');
      this.datasName = response.datas;
      this.service.base = response.base;
      this.base = this.service.base;
    } else {
      this.debug = !!this.findGetParameter('debug');
      this.timecodes = !!this.findGetParameter('timecodes');
      this.datasName = this.findGetParameter('datas');
      this.base = environment.datasServer;
      this.export = !!this.findGetParameter('export');
      this.inkleId = this.findGetParameter('inkle');
      this.inkleIdEn = this.findGetParameter('inkleen');
      this.kiosk = !!this.findGetParameter('kiosk');
      this.background = !!this.findGetParameter('background');
      if (this.kiosk) {
        this.debug = false;
        this.export = false;
        this.inkleId = '';
        this.inkleIdEn = '';
        this.timecodes = true;
        this.background = false;
      }
    }
    console.log("this.datasName", this.datasName);
    this.loadDatas();

    // this.mousedown.subscribe((datas) => console.log('mousedown', datas));
    // this.mousemove.subscribe((datas) => console.log('mousemove', datas));
    // this.mouseup.subscribe((datas) => console.log('mouseup', datas));

    this.dragStart.subscribe((datas) => {
      this.dragging = true;
      this.pauseVideo();
    } );
    this.dragMove.subscribe((datas) => {
      let width = this.progressBar.nativeElement.offsetWidth;
      let left = this.progressBar.nativeElement.offsetLeft;
      let percent = (datas.x0 + datas.deltaX - left) / width * 100;
      percent = Math.max(percent, 0);
      percent = Math.min(percent, 100);
      this.videoProgress = percent;
    });
    this.dragEnd.subscribe((datas) => {
      this.dragging = false;
      this.gotoVideo(this.videoProgress);
      this.unpauseVideo();
    });

  }

  preventDefault(event) {
    event.preventDefault();
    return false;
  }

  load(): any {
    let ret = null;
    if (this.isElectron()) {
      ret = of(this.electron.ipcRenderer.sendSync('load'));
    }
    return ret;
  }
  save(): any {
    let ret = null;
    if (this.isElectron()) {
      ret = of(this.electron.ipcRenderer.sendSync('save', { lastChoice: Math.random() }));
    }
    return ret;
  }

  ngAfterViewChecked(): void {
    if (this.canvasRef && this.canvasImgRef) {
      this.canvas = this.canvasRef.nativeElement;
      this.canvasImg = this.canvasImgRef.nativeElement;
      this.canvasImgCtx = (this.canvasImg.getContext('2d') as CanvasRenderingContext2D);
      this.afterViewChecked = true;
    }
    if (this.isReady()) {
      this.start();
    }
  }

  loadDatas(): void {
    this.service.loadDatasDev(this.datasName).subscribe((datas => {
      this.datasdev = datas;
      console.log(this.datasdev);
      this.service.loadDatas(this.datasName).subscribe((datas => {
        this.datas = datas;
        console.log(this.datas);

        this.sanitized = this.datas.conclusions.map((conclusion) => ({ src: this.sanitizeThisSrc('files/' + conclusion.image), style: this.sanitizeThis('files/' + conclusion.image) }));

        this.service.loadVideoFolders(this.datasName).subscribe(videoFolders => {
          this.videoFolders = videoFolders;
          console.log(this.videoFolders);

          let storiesLoader: Array<Observable<any>> = [];
          if (!!this.inkleId) {
            storiesLoader.push(this.service.loadInkleWriter(this.datasdev.story + this.inkleId + '.json', 0));
          } else {
            storiesLoader.push(this.service.loadStory(this.datasName, 0)); // fr
          }
          if (!!this.inkleIdEn) {
            storiesLoader.push(this.service.loadInkleWriter(this.datasdev.story + this.inkleIdEn + '.json', 1));
          } else {
            storiesLoader.push(this.service.loadStory(this.datasName, 1)); // en
          }
          forkJoin(storiesLoader).subscribe((datas) => this.onStoriesLoaded(datas));
        });
      }));
    }));
  }

  onStoriesLoaded(datas) {
    this.stories = datas;

    console.log('this.stories', this.stories, this.lang);
    this.story = new Story(this.stories[this.lang], this.datasdev.effects, this.lang);
    this.loaded = true;
    if (this.isReady()) {
      this.start();
    }
  }

  loadDatasLocal(): any {
    this.service.loadDatasLocal(this.datasName).subscribe(datas => {
      let response = 'mensonge';
      if (datas.response) {
        response = datas.response;
      }
      this.story.flags.set('dilemne_' + response, true);
      console.log('local datas loaded', datas);
    });
  }
  writeDatasLocal(datas) {
    this.service.writeDatasLocal(this.datasName, datas).subscribe(datas => {
      console.log('local datas writen', datas);
    });
  }

  onSplashClick(): void {
  }

  isReady(): boolean {
    return this.loaded && this.afterViewChecked && !this.startDone;
  }

  start(): void {
    this.clear();
    this.createScene();
    this.initSpheres();
    this.startRenderingLoop();

    this.runStitch(this.story.initial);
    // this.runConclusions();
    this.startDone = true;
  }

  /**********************************************************************/
  /* RESTART, SLEEP AND AUDIO LOOP **************************************************************/

  onClick(): void {
    if (!this.started) {
      if (!this.kiosk) {
        this.readAudioLoop();
      }
      this.started = true;
    }

    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
      // delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      console.log("activity event");
      if (!this.debug) {
        this.reload();
      }
    });
  }
  private readAudioLoop() {
    this.loopPlayer = new window.Audio();
    this.loopPlayer.loop = true;
    this.loopPlayer.volume = 0.3;
    this.service.loadMedia(this.base + this.datasName + '/filesdev/loop.mp3').subscribe((audio) => {
      this.loopPlayer.src = window.URL.createObjectURL(audio);
      this.loopPlayer.play();
    });
  }

  reload(): void {
    // ...
    this.goHome();
  }
  clear(): void {
    this.dragging = false;
    this.paused = false;
    this.lang = 0;
    this.homeQuestion = false;
    this.status = 'home';
    this.pseudo = '';
    this.history = [];
    this.stitch_duration = 0;
    this.selected = -1;
    this.conclusionMenu = false;
    this.story.flags.init();
    delete this.stitch;
    let initialEffect: Effect = this.story.effects.getEffect('init');
    this.doEffect(initialEffect);
    this.loadDatasLocal();
  }
  onBtnHome(): void {
    this.homeQuestion = true;
  }
  onBtnWide(): void {
    this.wide = !this.wide;
    if (this.wide){
      this.openFullscreen()
    } else {
      this.closeFullscreen()
    }
  }
  onBtnMute(): void {
    this.mute = !this.mute;
    if (this.mute){
      this.loopPlayer.volume = 0;
      if (this.audioPlayer){
        this.audioPlayer.volume = 0;
      }
    } else {
      this.loopPlayer.volume = 0.3;
      if (this.audioPlayer){
        this.audioPlayer.volume = 1;
      }
    }
  }
  onCredits(): void {
    this.credits = true;
  }
  onCreditsClose(): void {
    this.credits = false;
  }

  onHomeQuestion(bool: boolean): void {
    if (bool) {
      this.goHome();
    }
    this.homeQuestion = false;
  }
  goHome(): void {
    this.onLang(0);
    this.clear();
    this.runStitch(this.story.initial);
    this.stopAudio();
  }

  onLang(num: number) {
    if (this.lang != num) {
      this.lang = num;
      this.story = new Story(this.stories[this.lang], this.datasdev.effects, this.lang);
      this.runStitch(this.story.initial);
      this.loadDatasLocal();
    }
  }

  /**********************************************************************/
  /* STORY **************************************************************/


  public runStitch(path: string) {
    if (this.status == 'home' || this.status == 'stitch') {
      let stitch = this.story.getStitch(path);
      this.homeStitch = (stitch.path == this.story.initial);
      console.log('runStitch', stitch);
      this.keyboard = false;
      stitch.flagNames.forEach((flagName) => {
        let effect: Effect = this.story.effects.getEffect(flagName);
        this.doEffect(effect);
        this.keyboard = this.keyboard || flagName == 'keyboard';
      });
      // this.story.unsetFlagsEffects();
      this.status = 'fadeout';

      let delay: number = this.transitionDelay;
      if (!this.stitch) {
        delay = 0;
      }

      this.transitionSubscription = timer(delay).subscribe(() => {
        delete this.stitch;
        this.status = 'off';
        timer(10).subscribe(() => {
          this.selected = -1;
          this.stitch = stitch;
          this.title = this.story.title;
          this.history.push(this.stitch);
          this.story.updateFlags(this.stitch);
          if (this.stitch.flagNames.indexOf('mensonge') != -1) {
            this.writeDatasLocal({ response: 'mensonge' });
          } else if (this.stitch.flagNames.indexOf('verite') != -1) {
            this.writeDatasLocal({ response: 'verite' });
          }
          this.stitch_duration = 0;
          let timer_flag = this.stitch.flagNames.find((flag) => flag.substring(0, 6) == 'temps_');
          if (timer_flag) {
            let tab = timer_flag.split('_');
            if (tab.length == 2) {
              this.stitch_duration = parseInt(tab[1]);
            }
          }
          if (this.stitch_duration > 0) {
            this.startCountDown();
          }
          timer(10).subscribe(() => {
            this.status = 'stitch';
          });
        });
      });
    }
  }
  startCountDown() {
    this.countDown = 0;
    this.stopCountDown();
    this.countDownSubscription = this.countDown$.pipe(
      tap((v) => {
        this.countDown = (v / this.stitch_duration);
      }),
      last(),
      tap((v) => {
        console.log('end');
      })
    ).subscribe();
  }
  stopCountDown() {
    if (this.countDownSubscription) {
      this.countDownSubscription.unsubscribe();
      delete this.countDownSubscription;
    }
  }

  public onChoice(index: number, choice: Choice): void {
    this.selected = index;
    this.runStitch(choice.linkPath);
  }
  public onEnd(): void {
    this.runConclusions();
  }
  public runConclusions(): void {
    let effect: Effect = this.story.effects.getEffect('conclusions');
    this.doEffect(effect);
    delete this.stitch;
    this.selected = -1;
    this.status = 'conclusions_splash';
    // this.playConclusion(0);
  }
  public playConclusion(num): void {
    if (!this.timecodes){
      let effect: Effect = this.story.effects.getEffect('mute_2');
      this.doEffect(effect);
    } else {
      let effect: Effect = this.story.effects.getEffect('mute');
      this.doEffect(effect);
    }
    this.status = 'conclusions';
    delete this.currentVideo;
    this.conclusionIndex = -1;
    this.conclusionMenu = false;
    timer(100).subscribe(() => {
      this.conclusionIndex = num;
      this.playVideo({ base: '910* [J900]', inc: this.conclusionIndex }, false)

      this.service.loadText(this.base + this.datasName + '/filesdev/subtitles/lang' + this.lang + '/' + this.conclusionIndex + '.srt').subscribe((content) => {
        content = content.replaceAll(/[0-9]+,[0-9]+/ig, (ret) => {
          let tab = ret.split(',');
          return tab[0] + '.' + tab[1];
        });
        content = content.replaceAll(/--> [0-9.:]*/ig, (ret) => ret + ' line:90%');
        content = "WEBVTT \r\n\r\n" + content;
        var blob = new Blob([content], { type: 'text/vtt' });
        this.webvtt = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
      });
    });
  }

  public onReplay() {
    if (this.paused){
      this.unpauseVideo();
      this.conclusionMenu = false;
    } else {
      this.playConclusion(this.conclusionIndex);
    }
  }
  public onSkip() {
    this.conclusionMenu = true;
    this.pauseVideo();
  }
  public onSkipClose() {
    this.conclusionMenu = false;
    this.unpauseVideo();
  }


  /**********************************************************************/
  /* EFFECTS **************************************************************/

  public doEffect(effect: Effect): void {
    if (!effect) return;

    if (effect.map) {
      this.readImg(this.base + this.datasName + '/filesdev/images/' + effect.map);
    }
    if (effect.image) {
      this.image = this.sanitizer.bypassSecurityTrustStyle('url(' + this.base + this.datasName + '/filesdev/images/' + effect.image + ')');
    }
    if (effect.camera) {
      this.cameraPosTarget = new Camera(effect.camera);
      this.cameraMvt = new Camera();
    }
    if (effect.camera_mvt) {
      this.cameraMvt = new Camera(effect.camera_mvt);
    }
    if (effect.filter) {
      this.filter = effect.filter;
    }
    if (typeof effect.sound !== 'undefined') {
      if (effect.sound != '') {
        console.log(this.timecodes, effect.sound);
        if (!this.timecodes) {
          this.readAudio(this.base + this.datasName + '/filesdev/sounds/' + effect.sound);
        } else {
          let wav = effect.sound.replace('.mp3', '.wav');
          console.log('wav', wav);
          this.readAudio(this.base + this.datasName + '/filesdev/sounds_timecodes/' + wav);
        }
      } else {
        this.stopAudio();
      }
    }
    if (effect.speed) {
      this.speedTarget = 1 * effect.speed;
    }
    if (effect.amplitude) {
      this.amplitudeTarget = 1 * effect.amplitude;
    }
    // recurse
    if (effect.effects) {
      effect.effects.forEach((effectName) => {
        let effect = this.story.effects.getEffect(effectName);
        this.doEffect(effect);
      });
    }
  }

  private readAudio(sound: string) {
    this.service.loadMedia(sound).subscribe((audio) => {
      let playing = false;
      if (!this.audioPlayer) {
        this.audioPlayer = new window.Audio();
      } else {
        playing = this.audioPlayer.duration > 0 && !this.audioPlayer.paused;
      }
      this.audioPlayer.src = window.URL.createObjectURL(audio);
      this.audioPlayer.play();
    });
  }
  private stopAudio() {
    if (this.audioPlayer) {
      this.audioPlayer.pause();
    }
  }

  /**********************************************************************/
  /* KEYBOARD **************************************************************/

  public onLetter(letter: string): void {
    if (letter == '◄') {
      this.pseudo = this.pseudo.substring(0, this.pseudo.length - 1);
    } else {
      if (this.pseudo.length == 0) {
        this.pseudo += letter.toUpperCase();
      } else {
        this.pseudo += letter;
      }
    }
    this.story.flags.set('nom', this.pseudo);
  }

  /**********************************************************************/
  /* 3D STUFFS **************************************************************/

  public onResize(event: Event) {
    console.log('resize');
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
  }

  private createScene() {
    // Scene
    this.scene = new THREE.Scene();

    let bgColor = new THREE.Color(0x221F20);
    this.scene.background = bgColor;
    this.scene.fog = new THREE.Fog(bgColor, 0.5 * this.farClippingPlane, this.farClippingPlane);

    // Camera
    let aspectRatio = this.getAspectRatio();
    this.camera = new THREE.PerspectiveCamera(
      this.fieldOfView,
      aspectRatio,
      this.nearClippingPlane,
      this.farClippingPlane
    );

    this.cameraPos = new Camera({ ...this.cameraPosTarget });
    this.camera.position.x = this.cameraPos.px;
    this.camera.position.y = this.cameraPos.py;
    this.camera.position.z = this.cameraPos.pz;
  }

  private initSpheres() {
    this.elevationsTarget = [];
    let cp: number = 0;
    this.spheres = [];
    for (let i = 0, w = this.canvasImgWidth; i < w; i++) {
      for (let j = 0, h = this.canvasImgHeight; j < h; j++) {
        this.elevationsTarget[cp] = 0;
        let sphere = new THREE.SphereGeometry(2, 4, 4);
        // let sphere = new THREE.SphereGeometry(2, 16, 16);
        let sphereMesh = new THREE.Mesh(sphere, this.materialWhite);
        sphereMesh.position.x = (j - 50) * 24;
        sphereMesh.position.y = this.elevationsTarget[cp];
        sphereMesh.position.z = i * 24;
        this.scene.add(sphereMesh);
        this.spheres.push(sphereMesh);
        cp++;
      }
    }
    this.elevations = [...this.elevationsTarget];
  }

  private onImgRed(elevations: Array<number>) {
    this.elevationsTarget = elevations;
  }

  private animate(acc: number) {
    if (this.spheres) {
      this.speed = this.interpolate(this.speedTarget, this.speed, acc);
      this.amplitude = this.interpolate(this.amplitudeTarget, this.amplitude, acc);

      let cp = 0;
      for (let i = 0, w = this.canvasImgWidth; i < w; i++) {
        for (let j = 0, h = this.canvasImgHeight; j < h; j++) {
          this.elevations[cp] = this.interpolate(this.elevationsTarget[cp], this.elevations[cp], acc);
          this.spheres[cp].position.y = 3 * this.elevations[cp] + 3 * this.amplitude * Math.sin((i + j) * 1 + this.time * 5);
          cp++;
        }
      }
      // this.cameraPos = this.cameraPos.interpolate(this.cameraPosTarget, acc);
      this.cameraPos = this.cameraPos.interpolate(this.cameraPosTarget.add(this.cameraMvt), acc);
      this.camera.position.x = this.cameraPos.px;
      this.camera.position.y = this.cameraPos.py;
      this.camera.position.z = this.cameraPos.pz;
      this.camera.rotation.x = this.cameraPos.rx * Math.PI / 180;
      this.camera.rotation.y = this.cameraPos.ry * Math.PI / 180;
      this.camera.rotation.z = this.cameraPos.rz * Math.PI / 180;
    }
  }

  public interpolate(target: number, pos: number, acc: number): number {
    return (target + pos * acc) / (1 + acc);
  }

  private readImg(image: string) { // convert image pixels grey value to dots elevations array
    this.service.loadMedia(image).subscribe((img) => {
      createImageBitmap(img).then((image) => {
        this.canvasImgCtx.drawImage(image, 0, 0);
        let imgDatas = this.canvasImgCtx.getImageData(0, 0, this.canvasImgWidth, this.canvasImgHeight).data;
        let elevations = [];
        for (var i = 0, n = imgDatas.length; i < n; i += 4) {
          elevations.push(imgDatas[i]);
        }
        this.onImgRed(elevations);
      });
    });
  }

  private getAspectRatio() {
    return this.canvas.clientWidth / this.canvas.clientHeight;
  }

  private startRenderingLoop() {
    this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true });
    this.renderer.setPixelRatio(devicePixelRatio);
    this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight);

    let that: AppComponent = this;

    animationFrameScheduler.schedule(function () {
      that.renderer.render(that.scene, that.camera);
      let now = Date.now();
      let ellaspedTime = now - that.lastTick
      that.lastTick = now;
      that.ips = Math.round(1000 / ellaspedTime);
      if (that.ips && that.speed) {
        that.animate(that.ips);
        that.time += ellaspedTime / 4000 * that.speed;
      }
      this.schedule();
    }, 0, 0);
  }

  onBack() {
    this.history.pop();
    let latest = this.history.pop();
    this.runStitch(latest.path);
  }



  /**********************************************************************/
  /* VIDEO **************************************************************/

  playVideo(folderBaseAndInc, loop) {
    let folder: string = folderBaseAndInc.base;

    let folderSplit = folder.split('*');
    if (folderSplit.length > 1) {
      let num = parseInt(folderSplit.shift());
      if (folderBaseAndInc.inc != null) {
        num += folderBaseAndInc.inc;
      }
      folder = this.toStringLen(num, 3) + folderSplit.join('');
    }
    this.playVideoWeb(folder, loop);
  }
  pauseVideo() {
    if (this.timecodes){
      let effect: Effect = this.story.effects.getEffect('mute_1');
      this.doEffect(effect);
    }
    
    this.videoTag.forEach((video) => video.nativeElement.pause());
    this.paused = true;
  }
  unpauseVideo() {
    this.videoTag.forEach((video) => video.nativeElement.play());
    this.paused = false;
  }
  gotoVideo(percent) {
    this.videoTag.forEach((video) => {
      video.nativeElement.currentTime = video.nativeElement.duration / 100 * percent;
      video.nativeElement.play();
      this.paused = false;
    });
  }
  playVideoWeb(videoFolder: string, loop: boolean) {
    this.loop = loop;

    let sel = this.videoFolders.filter((elt) => {
      return elt.folder == videoFolder;
    });
    if (sel.length) {
      this.currentVideo = videoFolder + '/' + sel[0].video;
      this.paused = false;
      this.videoSubscription = interval(1000).subscribe(() => {
        this.videoUpdate();
      });
    }

  }
  videoUpdate() {
    if (!this.dragging){
      if (this.videoTag && this.videoTag.first && this.videoTag.first.nativeElement) {
        this.videoProgress = Math.round(100 * this.videoTag.first.nativeElement.currentTime / this.videoTag.first.nativeElement.duration);
      } else {
        this.videoProgress = 0;
      }
      this.cdf.detectChanges();
    }
    console.log(this.conclusionMenu);
  }
  onVideoEnded(e) {
    if (this.videoSubscription) {
      this.videoSubscription.unsubscribe();
      delete this.videoSubscription;
    }
    this.videoProgress = 100;
    // this.currentVideo = '';
    // this.openHome(); // ************************************* /**/
  }
  onVideoClick() {
    if (this.paused){
      this.unpauseVideo();
      this.conclusionMenu = false;
    } else {
      this.pauseVideo();
      this.conclusionMenu = true;
    }
  }



  /**********************************************************************/
  /* DEBUG **************************************************************/

  public onStitch(stitch: Stitch): void {
    this.runStitch(stitch.path);
  }
  public onEffect(effect: Effect): void {
    this.doEffect(effect);
  }

  openFullscreen() {
    let elem: any = window.document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    let elem: any = window.document;
    if (elem.exitFullscreen) {
      elem.exitFullscreen();
    } else if (elem.mozCancelFullScreen) {
      /* Firefox */
      elem.mozCancelFullScreen();
    } else if (elem.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitExitFullscreen();
    } else if (elem.msExitFullscreen) {
      /* IE/Edge */
      elem.msExitFullscreen();
    }
  }
  checkFullScreen(){
    let elem: any = window.document;
    if (!!(elem.fullscreenElement || elem.mozFullScreenElement || elem.webkitFullscreenElement || elem.msFullscreenElement)) {
      this.wide = true;
    } else {
      this.wide = false;
    }
  }


  /**********************************************************************/
  /* TOOLS **************************************************************/

  sanitizeThis(url) {
    return this.sanitizer.bypassSecurityTrustStyle('url(' + this.base + this.datasName + '/' + url + ')');
  }
  sanitizeThisSrc(url) {
    return this.sanitizer.bypassSecurityTrustUrl(this.base + this.datasName + '/' + url);
  }

  findGetParameter(parameterName: string): string {
    let result: string = '', tmp = [];
    let items = location.search.substr(1).split("&");
    for (let index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
  }

  toStringLen(num: number, len: number): string {
    let ret = '' + num;
    while (ret.length < len) {
      ret = '0' + ret;
    }
    return ret;
  }
}